(function(){
    function Forms(){
        this.sendAjaxForm = function(form) {
            var $form = $(form);
            var $formInitialContent = $form.html();
            var $lang = $('html').attr('lang');

            $form.on('submit', function(e) {
                var $fields = $(".form__item").removeClass("is-error");
                var $captchaField = $('.captcha__input', $form).removeClass("is-error");
                var options = {
                    type:     'post',
                    url:      '/json/send_form/',
                    dataType: 'json',
                    data    : {_do: 'send_form'},
                    success:  function(data) {
                        if (data.ok) {
                            $form.addClass('animated fadeOutLeft');
                            window.setTimeout(function(e){
                                $form.removeClass('animated fadeOutLeft');
                                $form.addClass('animated fadeInLeft');
                                if ($lang == 'rus'){
                                    $form.html('<h1 class="h2">Ваше сообщение успешно отправлено!</h1>');
                                }else{
                                    $form.html('<h1 class="h2">Your message has been successfully sent!</h1>');
                                }    
                            }, 700);
                            
                            window.setTimeout(function(e){
                                $form.removeClass('animated fadeInLeft');
                                $form.addClass('animated fadeOutLeft');    
                            }, 3700);

                            window.setTimeout(function(e){
                                $form.html($formInitialContent);
                                proj.forms.removeLabelsAddPlaceholders('.ajax-form');
                                $form.removeClass('animated fadeOutLeft');
                                $form.addClass('animated fadeInLeft');
                            }, 4700);
                            
                        } else if (data.errors) {
                            for (var p in data.errors) {
                                $fields.filter(".attr-"+p).addClass("is-error");
                                $('.is-error').addClass("animated shake");
                                   $('.is-error').on('animationend webkitAnimationEnd oAnimationEnd',  function () {
                                     $('.is-error').removeClass("animated shake");
                                });
                               
                                if (p == 'captcha'){
                                    $captchaField.addClass("is-error");
                                }
                            }
                        }
                    },
                    error:    function() {
                        alert('Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу');
                    }
                };

                $form.ajaxSubmit(options);
                return false;
            });
        }

        this.removeLabelsAddPlaceholders = function(form){
            var $form = $(form);
            $('.form__item', $form).each(function() {
                var resultLabelText = '';
                   var $labelStar = $('.form__required-star', $(this)).html();

                   $('.form__required-star', $(this)).remove();

                   var $labelText = $('.form__label', $(this)).html();

                   $('.form__label', $(this)).remove();

                if ($labelStar == '*'){
                    resultLabelText = $.trim($labelText)+'*';
                }else{
                     resultLabelText = $.trim($labelText);
                }

                var placeholderInput = $('input', $(this)).attr('placeholder', resultLabelText);
                var placeholderTextarea = $('textarea', $(this)).attr('placeholder', resultLabelText);
            });

            var $captchaLabelText = $('.captcha__label',$form).html();
            $captchaLabelText = $.trim($captchaLabelText);
            $('.captcha__label',$form).remove();
            var $placeholderCaptcha = $('.captcha__input', $form);
            $placeholderCaptcha.attr('placeholder', $captchaLabelText);
            console.log( $captchaLabelText);
        }

        this.maskedInputInit = function(){
            $('form input[name="phone"]').mask("+7 (999) 999-99-99", { placeholder: '-' });
        }
    }
    proj.forms = new Forms();
})();
